var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsThreeVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1650_8848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z",
    fill: "#5D5D5D",
    stroke: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.5C17.1046 9.5 18 8.60457 18 7.5C18 6.39543 17.1046 5.5 16 5.5C14.8954 5.5 14 6.39543 14 7.5C14 8.60457 14.8954 9.5 16 9.5Z",
    fill: "#5D5D5D",
    stroke: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26.5C17.1046 26.5 18 25.6046 18 24.5C18 23.3954 17.1046 22.5 16 22.5C14.8954 22.5 14 23.3954 14 24.5C14 25.6046 14.8954 26.5 16 26.5Z",
    fill: "#5D5D5D",
    stroke: "#5D5D5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1650_8848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThreeVertical);
export default __webpack_public_path__ + "static/media/DotsThreeVertical.7f4e455682c82673f88ffda8b0006aee.svg";
export { ForwardRef as ReactComponent };